<h3 mat-dialog-title>{{title}}</h3>

<mat-dialog-content>
    <p>Receive email notifications for updates to this {{data.subscription.subscribableType}}.</p>
    <p>You can manage your notifications at any time on your <a class="text-primary add-hover" (click)="closeAndRoute()">User Account Notifications page <i class="fa fa-external-link ml-1"></i></a>.</p>

    <form [formGroup]="form">
        <label>Frequency:</label>
        <mat-radio-group class="d-block" formControlName="frequency">
            <mat-radio-button value="instant">Notify me <b>immediately</b></mat-radio-button>
            <br/>
            <mat-radio-button value="daily">Send me <b>daily</b> updates</mat-radio-button>
            <br/>
            <mat-radio-button value="weekly">Send me <b>weekly</b> updates</mat-radio-button>
            <br/>
            <mat-radio-button
                *ngIf="data.isUserSubscribed"
                value="unsubscribe">I want to <b>unsubscribe</b></mat-radio-button>
        </mat-radio-group>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-dialog-close
            [disabled]="isSaving"
            class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="onSubmit()"
            [disabled]="isSaving"
            class="btn btn-primary">Confirm</button>
</mat-dialog-actions>
